import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid, Header } from "semantic-ui-react";
import { LineBreaks, RawHTML } from "../common";
import styles from "./styles.less";

class RoomsCancellationPolicy extends Component {
  getPaxTitles = room => {
    const { titles } = this.props;
    let result = "";
    if (room.Adults > 0) {
      result += `${room.Adults} ${titles.Adults}`;
    }
    if (room.Children > 0) {
      result += `, ${room.Children} ${titles.Children}`;
    }
    if (room.Infants > 0) {
      result += `, ${room.Infants} ${titles.Infants}`;
    }
    return result;
  };

  renderText = html => (
    <LineBreaks>
      <div className={styles.text}>
        <RawHTML html={html} />
      </div>
    </LineBreaks>
  );

  renderTitle = (room, index) => {
    const { titles } = this.props;
    const toRender = (
      <LineBreaks>
        <div className={styles.title}>
          <RawHTML
            html={`${titles.Room} ${index + 1} ( ${
              room.roomName
            } - ${this.getPaxTitles(room)} ) :`}
          />
        </div>
      </LineBreaks>
    );

    return (
      <Header inverted as="h2" content={toRender} className={styles.title} />
    );
  };

  render() {
    const { cpList, isRtl } = this.props;
    const textAlign = isRtl ? "right" : "left";
    return (
      <Grid
        textAlign={textAlign}
        className={cx(styles.roomsCancellationPolicy, { [styles.rtl]: isRtl })}
      >
        {cpList.map((cp, index) => {
          return (
            <Grid.Row className={styles.row} key={index}>
              <Grid.Column width={16}>
                {this.renderTitle(cp, index)}
              </Grid.Column>
              <Grid.Column width={16}>
                {this.renderText(cp.cancellationPolicy)}
              </Grid.Column>
            </Grid.Row>
          );
        })}
      </Grid>
    );
  }
}

RoomsCancellationPolicy.propTypes = {
  isRtl: PropTypes.bool,
  cpList: PropTypes.array,
  titles: PropTypes.object
};

export default RoomsCancellationPolicy;



// WEBPACK FOOTER //
// ./src/components/RoomsCancellationPolicy/RoomsCancellationPolicy.js